import React from 'react';
import { WorkspaceThumbnail } from '../WorkspaceThumbnail';
import { CloseButton } from 'react-bootstrap';
import { CloseIconBig } from '../icons/CloseIconBig';
import { ArrowUpIcon } from '../icons/ArrowUpIcon';
import { useDispatch } from 'react-redux';
import { CONTENT_GROUP_ACTION } from '../../constants';
import { minimized_content_groupActions } from '../../actions';

const MinimizedCard = ({ 
    card,
    workspace,
    toggle = false,
    mobile = false,
    ...props 
}) => {
    const dispatch = useDispatch();
    
    const handleCloseButton = () => {
        if(toggle){
            props?.setCollapsed?.(true)

            return;
        } else {
            const onBefore = () => {
                dispatch({
                    type: CONTENT_GROUP_ACTION.REMOVE_MINIMIZED_CARD,
                    payload: card.id
                });
            }

            const params = {
                content_group_id: card.id,
                onBefore
            }

            dispatch(minimized_content_groupActions.removeMinimizedContentGroup(params));
        }
    }

    const handleOpenCard = () => {
        dispatch({ type: CONTENT_GROUP_ACTION.OPEN_CARD_MODAL, payload: { id: card.id, workspace_id: workspace?.id } });
    };

    const className = mobile ?
                        'minimize-card rounded bg-white py-3 px-2 d-flex align-items-center position-relative border-0' :
                        'minimize-card rounded bg-white mx-2 my-2 px-2 d-flex align-items-center position-relative';

    return (
        <div className={className}>
            <div className='d-flex justify-content-between w-100 align-items-center'>
                <div className='d-flex align-items-center'>
                    {
                        workspace?.logo?.thumb_url && (
                            <WorkspaceThumbnail imageUrl={workspace?.logo?.thumb_url} className={'me-2'}/>
                        )
                    }
                    <div 
                        className="minimize-card-header cursor-pointer"
                        onClick={handleOpenCard}
                    >
                        <span className='truncate'>{card?.name}</span>
                    </div>
                </div>

                <div 
                    className={`minimize-card-close-btn h-100 cursor-pointer d-flex align-items-center ${!mobile ? 'me-2' : ''}`}
                    onClick={handleCloseButton}
                >
                    {
                        toggle ?
                            <ArrowUpIcon />
                        :
                        <CloseIconBig color={'#23000'}/>
                    }
                    
                </div>
            </div>

        </div>
    );
};

export { MinimizedCard };